import { gql } from '__generated__';

export default gql(`
  query GetTeamFilters($project_id: ID!, $events: [ID!], $search: String, $min_size: Int, $max_size: Int) {
    project(id: $project_id) {
      id
      team_stats(events: $events, search: $search, min_size: $min_size, max_size: $max_size) {
        teams
        registrations
      }
    }
  }
`);
